var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    `${_vm.baseClass}`,
    `${_vm.baseClass}--background-${_vm.backgroundStyle}`,
    `${_vm.baseClass}--mode-${_vm.mode}`,
  ]},[_c('div',{class:`${_vm.baseClass}--balls`},[_c('div',{class:`${_vm.baseClass}--ball`}),_c('div',{class:`${_vm.baseClass}--ball`}),_c('div',{class:`${_vm.baseClass}--ball`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }